import React from "react";
import { useRef } from "react";

import { useState, useEffect } from "react";
import axios from "axios";
import { baseurladdress } from "../baseurl";
import moment from "moment";
import { useNavigate } from "react-router-dom";

import "datatables.net-dt/js/dataTables.dataTables";
import "datatables.net-dt/css/jquery.dataTables.min.css";
import $ from "jquery";

function Interassignment(params, { refresh }) {
  const navigate = useNavigate();
  const accesstoken = localStorage.getItem("token");
  const accessuserid = localStorage.getItem("id");
  const tableRef = useRef(null);

  const [dept, setdept] = useState([]);
  const [branch_name, setbranch_name] = useState([]);

  const [staffCode, setStaffcode] = useState("");
  const [data, setData] = useState([]);
  const Swal = require("sweetalert2");
  const [searchVal, setSearchVal] = useState("");
  const selectedOption =
    params.selectedOption != "" ? params.selectedOption : 0;
  const searchValue = params.searchValue != "" ? params.searchValue : 0;
  const [selectedOptions, setselectedOptions] = useState(selectedOption);
  // const [branch, setBranch] = useState(searchValue);
  // const [depts, setDepts] = useState(searchValue);
  const [filterValue, setFilterValue] = useState(searchValue);
  // console.log("selectedOption-Inte", selectedOption);
  // console.log("searchValue-inte", searchValue);

  const hasValidSearch = (option, value, code) => {
    if (!["1", "2", "3", 1, 2, 3].includes(option)) {
      return false;
    }

    if (String(option) === "3") {
      return !!String(code ?? value ?? "").trim();
    }

    return value !== "" && value !== 0 && value !== "0" && value != null;
  };

  useEffect(() => {
    if (selectedOptions === "1") {
      getbranch();
    } else if (selectedOptions === "2") {
      getdept();
    }
  }, [selectedOptions]);

  const showToast = (icon, title) => {
    const Toast = Swal.mixin({
      toast: true,
      position: "top-end",
      showConfirmButton: false,
      timer: 2500,
      timerProgressBar: true,
      didOpen: (toast) => {
        toast.addEventListener("mouseenter", Swal.stopTimer);
        toast.addEventListener("mouseleave", Swal.resumeTimer);
      },
    });

    Toast.fire({
      icon,
      title,
    });
  };

  const getbranch = () => {
    axios
      .get(baseurladdress + `getallbranchs`, {
        headers: { Authorization: `Bearer ${accesstoken}` },
      })
      .then((res) => {
        const data = res.data.response;
        // console.log(data);
        const user = data.map((item, index) => {
          return <option value={item.branch_id}> {item.branch_name} </option>;
        });
        setbranch_name(user);
      })
      .catch((error) => {
        alert(error);
      });
  };

  // get all departments

  const getdept = () => {
    axios
      .get(baseurladdress + `getalldepts`, {
        headers: { Authorization: `Bearer ${accesstoken}` },
      })
      .then((res) => {
        const data = res.data.response;
        // console.log(data);
        const dept = data.map((item, index) => {
          return <option value={item.dept_id}> {item.dept_name} </option>;
        });
        setdept(dept);
      })
      .catch((error) => {
        alert(error);
      });
  };

  function Editinterassign(staff_id) {
    sessionStorage.setItem("selectedOptions", selectedOptions);
    sessionStorage.setItem("searchVal", filterValue);
    navigate("/editinterassignment/" + staff_id, {
      state: {
        tab: "inter",
        selectedOptions: selectedOptions,
        searchVal: filterValue,
      },
    });
  }

  const searchByOption = () => {
    setData([]);
    let newVal = "";

    if (selectedOptions === "1") {
      if (!filterValue) {
        showToast("error", "Please choose a Branch");
        return;
      }

      newVal = filterValue;
    } else if (selectedOptions === "2") {
      if (!filterValue) {
        showToast("error", "Please choose a Department");
        return;
      }

      newVal = filterValue;
    } else if (selectedOptions === "3") {
      newVal = staffCode.trim();

      if (!newVal) {
        showToast("error", "Please enter a Staff Code");
        return;
      }

      setFilterValue(newVal);
    } else {
      showToast("error", "Please choose a search option");
      return;
    }

    fetchDataByValue(selectedOptions, newVal);
  };

  function AddinterShift() {
    sessionStorage.setItem("selectedOptions", selectedOptions);
    sessionStorage.setItem("searchVal", filterValue);
    navigate("/AddIntershift", {
      state: {
        tab: "inter",
        selectedOptions: selectedOptions,
        searchVal: filterValue,
      },
    });
    // navigate("/AddIntershift");
  }

  // const deleteInterShift = ($ids) => {
  //   Swal.fire({
  //     title: "Are you sure?",
  //     text: "You won't be able to revert this!",
  //     icon: "warning",
  //     showCancelButton: true,
  //     confirmButtonColor: "#3085D6",
  //     cancelButtonColor: "#d33",
  //     confirmButtonText: "Yes, delete it!",
  //   }).then((result) => {
  //     if (result.isConfirmed) {
  //         axios
  //           .post(baseurladdress + `deleteIntershift/` + $ids, data, {
  //             headers: {
  //               Authorization: `Bearer ${localStorage.getItem("token")}`,
  //             },
  //           })
  //           .then((result) => {
  //             console.log("reslt:", result);
  //             const Data = result.data.status;
  //             console.log("selectedOptions:", selectedOptions);
  //             console.log("filterValue:", filterValue);
  //             if (Data == "deleted") {
  //               const Toast = Swal.mixin({
  //                 toast: true,
  //                 position: "top-end",
  //                 showConfirmButton: false,
  //                 timer: 2500,
  //                 timerProgressBar: true,
  //                 didOpen: (toast) => {
  //                   toast.addEventListener("mouseenter", Swal.stopTimer);
  //                   toast.addEventListener("mouseleave", Swal.resumeTimer);
  //                 },
  //               });
  //               Toast.fire({
  //                 icon: "success",
  //                 title: "Inter shift data Deleted Successfully",
  //               });
  //               // fetchDataByValue(selectedOptions, filterValue);
  //             }
  //           });

  //     }
  //   });
  // };

  const deleteInterShift = ($ids) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085D6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      if (result.isConfirmed) {
        axios
          .post(baseurladdress + `deleteIntershift/` + $ids, data, {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("token")}`,
            },
          })
          .then((result) => {
            console.log("reslt:", result);
            const Data = result.data.status;
            console.log("selectedOptions:", selectedOptions);
            console.log("filterValue:", filterValue);
            if (Data == "deleted") {
              const Toast = Swal.mixin({
                toast: true,
                position: "top-end",
                showConfirmButton: false,
                timer: 2500,
                timerProgressBar: true,
                didOpen: (toast) => {
                  toast.addEventListener("mouseenter", Swal.stopTimer);
                  toast.addEventListener("mouseleave", Swal.resumeTimer);
                },
              });
              Toast.fire({
                icon: "success",
                title: "Inter shift data Deleted Successfully",
              });

              fetchDataByValue(selectedOptions, filterValue);
            }
          });
      }
    });
  };

  const fetchDataByValue = (selectdVal, newVal) => {
    destroyDataTable(); // ✅ destroy old instance first
    axios
      .get(`${baseurladdress}findallshiftassignments/${selectdVal}/${newVal}`, {
        headers: { Authorization: `Bearer ${accesstoken}` },
      })
      .then((res) => {
        const status = res.data.status;
        if (status === "success") {
          const datas = Array.isArray(res.data.response)
            ? res.data.response
            : [];

          setData(datas); // ✅ Now safe to set new data

          if (datas.length === 0) {
            showToast("info", res.data.message || "No data found");
          }
        } else {
          setData([]);
          showToast("info", res.data.message || "No data found");
        }
      })
      .catch((error) => {
        setData([]);
        alert("Error fetching data: " + error);
      });
  };

  // // useEffect inside your component
  useEffect(() => {
    if (hasValidSearch(selectedOption, searchValue, staffCode)) {
      fetchDataByValue(selectedOption, searchValue);
    } else {
      setData([]);
    }
  }, [refresh]);

  const destroyDataTable = () => {
    if (tableRef.current && $.fn.DataTable.isDataTable(tableRef.current)) {
      $(tableRef.current).DataTable().destroy();
    }
  };

  const initDataTable = () => {
    setTimeout(() => {
      $(tableRef.current).DataTable({
        pageLength: 10,
        destroy: true, // safety net
      });
    }, 0);
  };

  useEffect(() => {
    if (data && data.length > 0) {
      initDataTable(); // ✅ reinit
    }
  }, [data]);

  return (
    <>
      <div class="card-body">
        <div class="tab-content">
          <div class="tab-pane fade show active" id="user" role="tabpanel">
            <div class="card bg-light">
              <div class="card-header">
                <div class="card-body mb-0">
                  <div className="form-row">
                    <div className="col-md-3">
                      <h6>Select Option</h6>
                      <select
                        className="form-control select"
                        name="options"
                        value={selectedOptions}
                        onChange={(e) => {
                          setselectedOptions(e.target.value);
                          setFilterValue(""); // reset filter value on change
                        }}
                      >
                        <option value="0">Select</option>
                        <option value="1">Branch wise</option>
                        <option value="2">Department wise</option>
                        <option value="3">Staff Code</option>
                      </select>
                    </div>

                    {/* Common Dropdown for Branch or Department */}
                    {(selectedOptions === "1" || selectedOptions === "2") && (
                      <div className="col-md-3">
                        <h6>
                          {selectedOptions === "1" ? "Branch" : "Department"}
                        </h6>
                        <select
                          className="form-control select"
                          name="filter"
                          value={filterValue}
                          onChange={(e) => setFilterValue(e.target.value)}
                        >
                          <option value="">
                            Select{" "}
                            {selectedOptions === "1" ? "Branch" : "Department"}
                          </option>
                          {selectedOptions === "1" ? branch_name : dept}
                        </select>
                      </div>
                    )}

                    {/* Staff ID Input */}
                    {selectedOptions === "3" && (
                      <div className="col-md-3">
                        <h6>Staff Code</h6>
                        <input
                          type="text"
                          className="form-control"
                          name="staffId"
                          placeholder="Enter Staff code"
                          value={staffCode}
                          onChange={(e) => setStaffcode(e.target.value)}
                        />
                      </div>
                    )}

                    <div className="col-md-2">
                      <button
                        type="button"
                        className="btn btn-primary mb-2"
                        style={{ marginTop: "27px" }}
                        onClick={searchByOption}
                      >
                        Search
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="d-flex justify-content-end mt-2">
              <button
                type="button"
                className="btn plus-icon d-flex align-items-center"
                style={{ marginRight: "50px" }}
                onClick={() => AddinterShift()}
              >
                <span style={{ fontSize: "1.2rem" }}>
                  <i className="fa fa-plus-circle text-success"></i>
                </span>
                <span
                  style={{ fontSize: "0.7rem", color: "black", padding: "5px" }}
                >
                  {" "}
                  ADD
                </span>
              </button>
            </div>

            <div className="col-lg-12">
              <div className="card">
                <div className="card-body">
                  <div className="table-responsive">
                    <table
                      className="table table-bordered table-responsive-sm"
                      id="shiftinter"
                      ref={tableRef}
                    >
                      <thead>
                        <tr>
                          <th>Sl.No</th>
                          <th>Staff Name</th>
                          <th>Branch</th>
                          <th>Dept Name</th>
                          <th>Shift Branch</th>
                          <th>Shift Type</th>
                          <th>From Date</th>
                          <th>To Date</th>
                          <th style={{ textAlign: "center" }}></th>
                        </tr>
                      </thead>
                      <tbody>
                        {Array.isArray(data) && data.length > 0 ? (
                          data.map((item, index) => {
                            const fromDateFormatted = item.shift_from
                              ? moment(item.shift_from).format("DD-MM-YYYY")
                              : "";
                            const toDateFormatted = item.shift_to
                              ? moment(item.shift_to).format("DD-MM-YYYY")
                              : "";

                            return (
                              <tr
                                id={"chk" + item.staff_id}
                                key={item.staff_id}
                              >
                                <td>{index + 1}</td>
                                <td>{item.staff_name}</td>
                                <td>{item.branch_name}</td>
                                <td>{item.dept_name}</td>
                                <td>{item.shiftbranch_name}</td>
                                <td>{item.shifttype_name}</td>
                                <td>{fromDateFormatted}</td>
                                <td>{toDateFormatted}</td>
                                <td style={{ textAlign: "center" }}>
                                  {new Date(item.crtd_on)
                                    .toISOString()
                                    .split("T")[0] ===
                                  new Date().toISOString().split("T")[0] ? (
                                    <i
                                      className="text-danger fa fa-trash"
                                      onClick={() => deleteInterShift(item.id)}
                                      style={{ cursor: "pointer" }}
                                    ></i>
                                  ) : (
                                    <i
                                      className="text-muted fa fa-trash"
                                      style={{
                                        cursor: "not-allowed",
                                        opacity: 0.5,
                                      }}
                                      title="Only today's records can be deleted"
                                    ></i>
                                  )}
                                </td>
                              </tr>
                            );
                          })
                        ) : (
                          <tr>
                            <td colSpan="9" style={{ textAlign: "center" }}>
                              No data found
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Interassignment;
